import { Box } from "@chakra-ui/react";
import config from "config/config";
import { useEffect, useState } from "react";
import type { SbEditableComponentProps } from "types/storyblok";

const otButtonProps = {
  id: "ot-sdk-btn",
  className: "ot-sdk-show-settings",
};

export const OneTrustSettingsButton = ({
  buttonText,
  sbEditable,
}: SbEditableComponentProps<{ buttonText: string }>) => {
  const isOneTrustEnabled = config.oneTrustEnabled === "enabled";
  const [buttonProps, setButtonProps] = useState(null);

  useEffect(() => {
    setButtonProps(otButtonProps);
    if (window.OneTrust != null) {
      window.OneTrust.Init();
      setTimeout(() => {
        window.OneTrust?.LoadBanner();
      }, 1000);
    }
  }, []);

  if (!isOneTrustEnabled) return null;

  return (
    <Box {...sbEditable}>
      <button type="button" {...buttonProps}>
        {buttonText}
      </button>
    </Box>
  );
};
